import type { FunctionComponent } from 'react';

import { Modal } from '@/core/tamagoshi/Modal/Modal';
import { ModalHeader } from '@/core/tamagoshi/Modal/ModalHeader';

import { CouponModalContent } from './CouponModalContent';
import { termsTitle } from './translations';

import styles from './CouponModal.module.scss';

export interface CouponModalProps {
  handleClose: () => void;
}

export const CouponModal: FunctionComponent<CouponModalProps> = ({
  handleClose,
}) => (
  <Modal onClose={handleClose} preventEventPropagation>
    <ModalHeader className={styles.termsTitle}>{termsTitle}</ModalHeader>
    <CouponModalContent />
  </Modal>
);

CouponModal.displayName = 'CouponModal';
